module.exports = __webpack_public_path__ + "static/img/Stephen-Coniglio.d9a7e1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Stephen-Coniglio.jpg
// module id = NB67
// module chunks = 0